/**
 * Created by Ning Jiang on 9/26/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";

export class TombstoneReelAreaView extends ReelAreaView {

    private _reelMasks:PIXI.Graphics[] = [];

    constructor() {
        super();
    }

    protected UpdateReelAreaMask():void {
        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            const reelMaskShape:PIXI.Graphics = new PIXI.Graphics();
            reelMaskShape.beginFill(0xFFFFF, 1);
            if(reelId === 0 || reelId === 4) {
                reelMaskShape.drawRect(-130, 150, 260, GameConfig.instance.SYMBOL_HEIGHT * 2 + 40);
            } else {
                reelMaskShape.drawRect(-105, -20, 210, GameConfig.instance.REEL_AREA_HEIGHT);
            }
            reelMaskShape.endFill();

            if(this._reelMasks[reelId] != null) {
                this._reelViews[reelId].removeChild(this._reelMasks[reelId]);
            }
            this._reelMasks[reelId] = reelMaskShape;
            this._reelViews[reelId].addChild(reelMaskShape);
            this._reelViews[reelId].mask = reelMaskShape;
        });
    }

    public addReelView(reel:ReelController):void {
        super.addReelView(reel);

        if(reel.reelId === 1 && this._reelViews[0] != null) {
            this.addChild(this._reelViews[0]);
        }

        if(reel.reelId === 3 && this._reelViews[4] != null) {
            this.addChild(this._reelViews[4]);
        }
    }
}